import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { SKIP_ERROR_TOAST } from 'src/app/interceptors/error.interceptor';

export type ReportReason = 'copyright' | 'inappropriate' | 'misleading' | 'scam' | 'other';

/** The choices shown to buyers (same values as the backend's Report.REASON_CHOICES). */
export const REPORT_REASONS: { value: ReportReason; label: string; hint: string }[] = [
  { value: 'copyright', label: 'Copyright or stolen work', hint: "It uses someone else's art, maps or text without permission." },
  { value: 'inappropriate', label: 'Inappropriate content', hint: 'Offensive, hateful or not suitable for the store.' },
  { value: 'misleading', label: 'Misleading listing', hint: "The pictures or description don't match what you get." },
  { value: 'scam', label: 'Suspected scam', hint: 'It looks like a fake or a trick to take money.' },
  { value: 'other', label: 'Something else', hint: 'Tell us what is wrong below.' },
];

/** Flag a store item (or shop) for staff to review in the admin. */
@Injectable({ providedIn: 'root' })
export class ReportService {
  private apiUrl = serviceurl + 'api/v1/reports';

  constructor(private http: HttpClient) {}

  reportListing(listingId: number, reason: ReportReason, details: string): Observable<unknown> {
    // The report form shows its own messages (already reported, etc.).
    return this.http.post(`${this.apiUrl}/`, { listing: listingId, reason, details }, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    });
  }
}
